import {useState} from 'react'

interface InputFocusListeners {
  onFocus?: () => void
  onBlur?: () => void
}

export type UseInputFocus = [boolean, InputFocusListeners]

/**
 * Hook for watching the focus state of an form element.
 */
export const useInputFocus = (): UseInputFocus => {
  const [inputfocus, setInputFocus] = useState(false)
  return [
    inputfocus,
    {
      onFocus: () => {
        setInputFocus(true)
      },
      onBlur: () => {
        setInputFocus(false)
      }
    }
  ]
}
